import { useLocation } from '@ecomm/framework'
import { useNinetailedFeatureFlag } from '..'

export const usePriceAboveFoldExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '1EZdq1UMf3QRd4dyKSiN2N' })

export const useOdmonExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '15AAdXWYGGLjW7WaZYuxK6' })

export const useOdmonVideoDogAdExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '3ZltdGvGdUDiYH0TCWYEmL' })

export const useCartLineItemPriceDisplayExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '1OTIFsd8Nufmoykd9N020Q' })

export const useCameraOnlyLPCTAExperience = () => {
  const { isVariant } = useNinetailedFeatureFlag({
    baselineId: 'Lk6Je2UE8TDHICWt3ptLl'
  })
  const location = useLocation()

  return {
    isCameraOnlyVariant: location.pathname === '/cameras-landing' && isVariant
  }
}

export const useAlarmSensorPromoBannerExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '78nHqea55nQy2DOlV8lu7W' })

export const useOdmonIntentQuizExperience = () =>
  useNinetailedFeatureFlag({
    baselineId: '7L3bO9ovXkdMEhHTIdDl71'
  })
